import setpAlertAddress from '../../components/alert-address'
import BackToIndex from '../../components/back-to-index'
export default {
  setpAlertAddress,
  BackToIndex
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/form/resources/components.js